/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `DropoffGate.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { DropoffGate } from "./DropoffGate";

import { Dropoff } from "./Dropoff";
import { Gate } from "./Gate";
import { Project } from "./Project";

export abstract class DropoffGateModel {
    id: number;
    banned: boolean;
    createdAt: Dayjs;
    dropoffId: number;
    gateId: number;
    isDefault: boolean;
    projectId: number;
    updatedAt: Dayjs;
    dropoff: Dropoff | null | undefined;
    gate: Gate | null | undefined;
    project: Project | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        banned: boolean,
        createdAt: Dayjs,
        dropoffId: number,
        gateId: number,
        isDefault: boolean,
        projectId: number,
        updatedAt: Dayjs,
        dropoff: Dropoff | null | undefined,
        gate: Gate | null | undefined,
        project: Project | null | undefined
    ) {
        this.id = id;
        this.banned = banned;
        this.createdAt = createdAt;
        this.dropoffId = dropoffId;
        this.gateId = gateId;
        this.isDefault = isDefault;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.dropoff = dropoff;
        this.gate = gate;
        this.project = project;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): DropoffGate {
        const newObject = new DropoffGate(
            json["id"],
            json["banned"],
            dayjs(json["created_at"]).tz(timezone),
            json["dropoff_id"],
            json["gate_id"],
            json["is_default"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["dropoff"] == null ? json["dropoff"] : Dropoff.fromApiObject(json["dropoff"], timezone),
            json["gate"] == null ? json["gate"] : Gate.fromApiObject(json["gate"], timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            banned: this.banned,
            created_at: this.createdAt,
            dropoff_id: this.dropoffId,
            gate_id: this.gateId,
            is_default: this.isDefault,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            dropoff_attributes: this.dropoff?.toApiObject(visited),
            gate_attributes: this.gate?.toApiObject(visited),
            project_attributes: this.project?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): DropoffGate {
        const clone = Object.create(this) as DropoffGate;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
